import { createFileRoute } from '@tanstack/react-router'
import { ShiftAssignmentEditor } from './-ShiftAssignmentEditor'

// ModuleGuard komt van de shifts-route.tsx layout — geen wikkel per pagina.
export const Route = createFileRoute('/hr/shifts/assignments/$id')({
  component: ShiftAssignmentDetail,
})

function ShiftAssignmentDetail() {
  const { id } = Route.useParams()
  return <ShiftAssignmentEditor id={id} />
}
